import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import {
  MdClose,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
} from "react-icons/md";
import { MdModeEdit } from "react-icons/md";
import { FaBell, FaBellSlash, FaCalendarDay, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { PiArrowBendUpRightBold } from "react-icons/pi";
import { BsFillCursorFill } from "react-icons/bs";
import { PiDotsThreeOutlineFill } from "react-icons/pi";
import { MdNotificationsActive } from "react-icons/md";
import { IoExitOutline } from "react-icons/io5";
import { IoMdSettings } from "react-icons/io";
import { FcAbout } from "react-icons/fc";
import { IoIosLink } from "react-icons/io";
import { FaPoll } from "react-icons/fa";
import { SlNote } from "react-icons/sl";
import { FaCalendarDays, FaUserGroup } from "react-icons/fa6";
import { IoIosAddCircleOutline, IoMdAdd } from "react-icons/io";
import { FaBookmark } from "react-icons/fa";
import { FaRegNewspaper } from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";
import LinkedInPost from "./LinkedInPost";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import EditGroupModal from "../../Modals/EditGroupModal";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import EastIcon from "@mui/icons-material/East";
import GroupPostModal from "../../Modals/GroupPostModal";
import PollModal from "../../Modals/PollModal";
import EmojiPicker from "emoji-picker-react";
import { PiDotsThree } from "react-icons/pi";
import { FaRegBookmark, FaSave, FaLink, FaEdit, FaTrash } from "react-icons/fa";
import { FaCommentSlash } from "react-icons/fa6";
import { MdThumbUp, MdReply, MdSentimentSatisfied } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import { set } from "date-fns";
import EditPostModal from "../../Modals/EditPost/EditPostModal";
import Swal from "sweetalert2";
import { useMemo } from "react";
import PropTypes from "prop-types";
import {
  Search,
  ChevronDown,
  ChevronRight,
  Check,
  X,
  Users,
} from "lucide-react";

const CustomAvatar = ({ src, alt, size = "medium" }) => {
  const sizeClasses = {
    small: "w-8 h-8",
    medium: "w-12 h-12",
    large: "w-16 h-16",
  };

  return (
    <div
      className={`${sizeClasses[size]} rounded-full overflow-hidden flex-shrink-0`}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        onError={(e) => {
          e.target.src = `https://ui-avatars.com/api/?name=${alt.charAt(
            0
          )}&background=5566c2&color=fff&size=128`;
        }}
      />
    </div>
  );
};

const Button = ({
  children,
  variant = "primary",
  size = "medium",
  disabled = false,
  onClick,
  className = "",
}) => {
  const baseClasses =
    "font-medium rounded-full focus:outline-none transition-all duration-200";
  const variantClasses = {
    primary: "bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-300",
    secondary:
      "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400",
  };
  const sizeClasses = {
    small: "px-3 py-1 text-sm",
    medium: "px-4 py-2",
    large: "px-6 py-3 text-lg",
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

const SearchBar = ({ value, onChange, placeholder = "Search..." }) => (
  <div className="relative w-full">
    <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
      <Search className="h-5 w-5 text-gray-400" />
    </div>
    <input
      type="text"
      className="w-full pl-11 pr-4 py-2.5 bg-gray-50 border border-gray-300 rounded-xl text-sm placeholder-gray-400 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 shadow-sm hover:shadow-md"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

const FilterButton = ({ label, isActive = false, onClick }) => (
  <button
    className={`flex items-center px-4 py-2 rounded-full border ${
      isActive
        ? "border-blue-600 bg-blue-50 text-blue-600"
        : "border-gray-300 hover:bg-gray-50"
    } transition-colors duration-200`}
    onClick={onClick}
  >
    <span className="mr-1">{label}</span>
    <ChevronDown className="h-4 w-4" />
  </button>
);

const FilterSection = () => {
  const [activeFilters, setActiveFilters] = useState([]);
  const toggleFilter = (filter) => {
    setActiveFilters((prev) =>
      prev.includes(filter)
        ? prev.filter((f) => f !== filter)
        : [...prev, filter]
    );
  };

  return (
    <div className="flex flex-wrap gap-2 mt-4 pb-4 border-b border-gray-200">
      <FilterButton
        label="Locations"
        isActive={activeFilters.includes("Locations")}
        onClick={() => toggleFilter("Locations")}
      />
      <FilterButton
        label="Current company"
        isActive={activeFilters.includes("Current company")}
        onClick={() => toggleFilter("Current company")}
      />
      <FilterButton
        label="School"
        isActive={activeFilters.includes("School")}
        onClick={() => toggleFilter("School")}
      />
      <button className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-300 hover:bg-gray-50 transition-colors duration-200">
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};

const CheckBox = ({ checked, onChange, disabled = false }) => (
  <div
    className={`w-6 h-6 rounded-sm flex items-center justify-center transition-colors duration-200 ${
      disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
    } ${
      checked
        ? "bg-green-600 border border-green-600"
        : "border border-gray-300"
    }`}
    onClick={disabled ? undefined : onChange}
  >
    {checked && <Check className="h-4 w-4 text-white" />}
  </div>
);

const ConnectionItem = ({ connection, onToggle }) => {
  const {
    user_id,
    name,
    headline,
    profile,
    isSelected,
    already_present,
    role,
    request_sent,
  } = connection;

  const isOwner = role === "Owner";
  const isManager = role === "Manager";
  const shouldHideCheckbox = already_present|| request_sent || isOwner || isManager;

  return (
    <div className="flex items-start gap-3 py-4 px-4 border-b border-gray-200 group hover:bg-gray-50 transition-colors duration-200">
      <div className="w-6 flex justify-center items-start">
        {!shouldHideCheckbox && (
          <CheckBox
            checked={!!connection.isSelected}
            onChange={() => onToggle(user_id)}
          />
        )}
      </div>
      <CustomAvatar src={profile ? profile : "/Images/user-img.jpg"} alt={name} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center">
          <h3 className="font-medium text-gray-900">{name}</h3>
          {(isOwner || isManager) && (
            <span className="ml-auto text-gray-500 text-sm">{role}</span>
          )}
        </div>
        <p className="text-sm text-gray-600 truncate">{headline}</p>
      </div>
    </div>
  );
};

const ConnectionsList = ({ connections, onToggle }) => (
  <div className="max-h-[400px] overflow-y-auto ">
    {connections.map((connection) => (
      <ConnectionItem
        key={connection.user_id}
        connection={connection}
        onToggle={onToggle}
      />
    ))}
  </div>
);

const SelectedConnectionsList = ({
  connections,
  onUnselect,
  onUnselectAll,
}) => {
  return (
    <div className="p-4 min-w-[200px]">
      <div className="flex justify-between items-center mb-4">
        <span className="text-gray-700 font-medium">
          {connections.length} selected
        </span>
        <button
          className="text-blue-600 hover:underline text-sm"
          onClick={onUnselectAll}
        >
          Unselect all
        </button>
      </div>

      <div className="space-y-3">
        {connections.map((connection) => (
          <div key={connection.user_id} className="flex items-center gap-2">
            <Avatar
              src={
                connection.profile ? connection.profile : "/Images/user-img.jpg"
              }
              alt={connection.name}
              size="small"
            />
            <span className="text-sm flex-1 truncate">{connection.name}</span>
            <button
              className="text-gray-400 hover:text-gray-600"
              onClick={() => onUnselect(connection.user_id)}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const ConnectionModal = ({ isOpen, onClose, connection, slug }) => {
  const [connections, setConnections] = useState(
    connection.map((c) => ({
      ...c,
      isSelected: false,
    }))
  );

  const [searchQuery, setSearchQuery] = useState("");

  const toggleSelection = useCallback((user_id) => {
    setConnections((prev) =>
      prev.map((connection) =>
        connection.user_id === user_id && !connection.isOwner
          ? { ...connection, isSelected: !connection.isSelected }
          : connection
      )
    );
  }, []);

  const unselectAll = useCallback(() => {
    setConnections((prev) =>
      prev.map((connection) => ({ ...connection, isSelected: false }))
    );
  }, []);

  const filteredConnections = useMemo(() => {
    if (!searchQuery) return connections;
    return connections.filter((connection) =>
      connection.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [connections, searchQuery]);

  const selectedConnections = useMemo(
    () => connections.filter((connection) => connection.isSelected),
    [connections]
  );
  const sendInvite = async (userIds) => {
    try {
      const response = await axios.post(
        `${BaseUrl}sendgroupinvite/${slug}`,
        {
          users: userIds,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );

      if (response.data.status === 200) {
        
        onClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col animate-fadeIn">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">
            Invite connections
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-2 border-b border-gray-300">
          <SearchBar
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder="Search by name"
          />
        </div>

        <div className="flex flex-1">
          <div className="basis-[70%] overflow-y-auto border-r border-gray-200">
            {/* <FilterSection /> */}
            <ConnectionsList
              connections={filteredConnections}
              onToggle={toggleSelection}
            />
          </div>

          <div className="basis-[30%]">
            <SelectedConnectionsList
              connections={selectedConnections}
              onUnselect={toggleSelection}
              onUnselectAll={unselectAll}
            />
          </div>
        </div>

        <div className="p-4 border-t border-gray-200 flex justify-end">
          <Button
            disabled={selectedConnections.length === 0}
            onClick={() =>
              sendInvite(selectedConnections.map((user) => user.user_id))
            }
          >
            Invite{" "}
            {selectedConnections.length > 0 ? selectedConnections.length : ""}
          </Button>
        </div>
      </div>
    </div>
  );
};

CustomAvatar.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

FilterButton.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

CheckBox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

ConnectionItem.propTypes = {
  connection: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    avatar: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    isOwner: PropTypes.bool,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
};

ConnectionsList.propTypes = {
  connections: PropTypes.arrayOf(PropTypes.object).isRequired,
  onToggle: PropTypes.func.isRequired,
};

SelectedConnectionsList.propTypes = {
  connections: PropTypes.arrayOf(PropTypes.object).isRequired,
  onUnselect: PropTypes.func.isRequired,
  onUnselectAll: PropTypes.func.isRequired,
};

ConnectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  connection: PropTypes.arrayOf(PropTypes.object).isRequired,
};
const Groupdetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [isloading, setIsLoading] = useState(false);
  const profile = useRef(null);
  const bg_profile = useRef(null);
  const [feed, setFeed] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [expandedPosts, setExpandedPosts] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(true);
  const [isaboutopen, setIsAboutOpen] = useState(false);
  const [isShared, setIsShared] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isLeave, setIsLeave] = useState(false);
  const [isnotify, setIsNotify] = useState(false);
  const [isnotification, setIsNotification] = useState(false);
  const [selected, setSelected] = useState("all");
  const [isSaved, setIsSaved] = useState(false);
  const [groupowner, setGroupOwner] = useState([]);
  const [showAll, setShowAll] = React.useState(false);
  const displayedAdmins = showAll ? groupowner : groupowner.slice(0, 1);

  const handleToggle = () => {
    if (groupowner.length > 1) {
      setShowAll(!showAll);
      }
    };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };
  const toggleDropdown2 = () => {
    setIsOpen2((prev) => !prev);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalopen, setModalopen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [pollOpen, setPollOpen] = useState(false);
  const [groupdata, setGroupData] = useState({});
  const [user, setUser] = useState({});
  const [groups, setGroups] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [showEditPostModal, setShowEditPostModal] = useState(false);
  const [connections, setConnections] = useState([]);
  const currentUserRef = useRef({});
  const [showOptions, setShowOptions] = useState(false);
  const showOptionRef = useRef(null);
  const showButtonRef = useRef(null);
  const [showshare, setShowShare] = useState(false);
  const showShareRef = useRef(null);
  const showshareButtonRef = useRef(null);
  const dropdownRef = useRef(null);
  const dropdown1Ref = useRef(null);
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const perPage = 5;
  const [members, setMembers] = useState([]);
  const [memberscount, setMembersCount] = useState("");
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        showOptionRef.current &&
        !showOptionRef.current.contains(event.target) &&
        !showButtonRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }

      if (
        showshare &&
        showShareRef.current &&
        !showShareRef.current.contains(event.target) &&
        !showshareButtonRef.current.contains(event.target)
      ) {
        setShowShare(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShared(false);
      }
      if (
        dropdown1Ref.current &&
        !dropdown1Ref.current.contains(event.target)
      ) {
        setIsSettings(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions, showshare]);

  const getEvents = async () => {
    try {
      const response = await axios.get(BaseUrl + "getEvents", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      if (response.data.status === 200) {
        setEvents(response.data.data.data);
        
      }
    } catch (error) {
      console.log(error);
     
    }
  };

  useEffect(() => {
    getgroups();
    getGroupdetails(slug);
    getuserdetails();
    getMembers();
    getEvents();
    getConnections();
    
  }, [slug]);

  const handleInviteConnections = () => {
    setIsModalOpen(true);
  };


  const getMembers = async () => {
    try {
      const response = await axios.get(
        BaseUrl + `groupmembers/${slug}`,

        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        setMembersCount(response.data.data.total);
        setMembers(response.data.data.members);
      }
    } catch (error) {
      console.error("Join request failed:", error);
    }
  };

  const getgroups = async () => {
    setIsLoading(true);
    const token = Cookies.get("token");
    try {
      const result = await axios.get(BaseUrl + "getgroups", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (result.data.status === 200) {
        setGroups(result.data.data.groups);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getuserdetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `userdetails/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
    
      setUser(response.data.data[0]);
      
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getGroupdetails = async (slug) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `getgroupdetails/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setGroupData(response.data.data);
      setGroupOwner(response.data.data.owner);
      
      currentUserRef.current = {
        profile_image: response.data.data.user.profile_image,
        name: response.data.data.user.name,
      };
    } catch (error) {
      console.error("Error fetching group details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getgroupfeed = async (page = 1) => { 
    
    if (isFetching) return;
    const token = Cookies.get("token");
    try {
      setIsFetching(true);
      const result = await axios.get(
        BaseUrl + `groupFeed/${slug}?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (result.data.status === 200) {
        const newFeed = result.data.data.feed;
        if (page === 1) {
          setFeed(newFeed);
        } else {
          setFeed((prev) => [...prev, ...newFeed]);
        }
        if (newFeed.length < perPage) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Error fetching groups feed:", error);
    } finally {
      setIsFetching(false);
    }
  };
  // Initial fetch
  useEffect(() => {
    setFeed([]);
    setPage(1);
    setHasMore(true);
    getgroupfeed(1);
  }, []);

  // Scroll handler with threshold and debounce
  useEffect(() => {
    let timeout;

    const handleScroll = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;

        // Trigger when 300px from bottom
        if (
          scrollTop + windowHeight >= docHeight - 300 &&
          !isFetching &&
          hasMore
        ) {
          setPage((prev) => {
            const nextPage = prev + 1;
            getgroupfeed(nextPage);
            return nextPage;
          });
        }
      }, 150); // Debounce delay
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, hasMore]);
  const getConnections = async () => {
    try {
      const response = await axios.get(BaseUrl + `connections/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setConnections(response.data.data.members);
    } catch (error) {
      console.error("Error fetching connections:", error);
    }
  };
  const aboutopenModal = () => {
    setIsAboutOpen(true);
  };
  const aboutcloseModal = () => {
    setIsAboutOpen(false);
  };
  const openShared = () => {
    setIsShared(true);
  };
  const closeShared = () => {
    setIsShared(false);
  };
  const openNotification = () => {
    setIsNotification(true);
  };
  const closeNotification = () => {
    setIsNotification(false);
  };
  const openSettings = () => {
    setIsSettings(true);
  };
  const closeSettings = () => {
    setIsSettings(false);
  };
  const openLeave = () => {
    setIsLeave(true);
  };
  const closeLeave = () => {
    setIsLeave(false);
  };
  const handleToggleSave = () => {
    setIsSaved((prev) => !prev);
  };

  const EmojiPickerWrapper = ({ onEmojiSelect, onClose, positionClass }) => {
    const pickerRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (pickerRef.current && !pickerRef.current.contains(e.target)) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    return (
      <div ref={pickerRef} className={`absolute z-50 ${positionClass}`}>
        <EmojiPicker
          onEmojiClick={(emojiData) => {
            onEmojiSelect(emojiData.emoji);
            onClose();
          }}
          width={300}
          height={350}
        />
      </div>
    );
  };

  const LinkedInPoll = ({ pollData, onVote, selectedOption }) => {
    const {
      question,
      options,
      totalVotes,
      user_name,
      user_profile,
      user_id,
      likes,
      has_Liked,
      is_saved,
      closes_at,
      created_at,
      slug,
      comments: pollComments,
      user_selected_option,
    } = pollData;
    

    const initialComments = Array.isArray(pollComments) ? pollComments : [];
    const [showAllComments, setShowAllComments] = useState(false);
    const [commentText, setCommentText] = useState("");
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [showReplyEmojiPicker, setShowReplyEmojiPicker] = useState(false);
    const isPollClosed = new Date() > new Date(closes_at);
    const canVote = !isPollClosed && selectedOption !== null;
    const [showOptions, setShowOptions] = useState(false);
    const showOptionRef = useRef(null);
    const showButtonRef = useRef(null);
    const [isLiked, setIsLiked] = useState(has_Liked);
    const [likeCount, setLikeCount] = useState(likes);
    const [comments, setComments] = useState(initialComments);
    const [commentLikes, setCommentLikes] = useState();
    const [commentisLiked, setCommentisLiked] = useState();
    const [showComments, setShowComments] = useState(false);
    const [replyingTo, setReplyingTo] = useState(null);
    const [replyText, setReplyText] = useState("");
    const [showAllReplies, setShowAllReplies] = useState({});
    const [canSave, setCanSave] = useState(is_saved);

    const formatTimeAgo = (dateString) => {
      const date = new Date(dateString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);

      if (diffInSeconds < 60) return "Just now";
      if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
      if (diffInSeconds < 86400)
        return `${Math.floor(diffInSeconds / 3600)}h ago`;
      return `${Math.floor(diffInSeconds / 86400)}d ago`;
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          showOptions &&
          showOptionRef.current &&
          !showOptionRef.current.contains(event.target) &&
          !showButtonRef.current.contains(event.target)
        ) {
          setShowOptions(false);
        }
      };

      if (showOptions) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showOptions]);

    const getpollresults = async (pollid) => {
      setIsLoading(true);
      try {
        const response = await axios.get(BaseUrl + `getPollResults/${pollid}`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        });

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    const handleLike = async (e) => {
      e.preventDefault();
      try {
        if (isLiked) {
          await axios.post(
            `${BaseUrl}grouppollunlike/${groupdata.id}/${pollData.id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Cookies.get("token")}`,
                Accept: "application/json",
              },
            }
          );

          setIsLiked(false);
          setLikeCount((prev) => prev - 1);
        } else {
          await axios.post(
            `${BaseUrl}grouppolllike/${groupdata.id}/${pollData.id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Cookies.get("token")}`,
                Accept: "application/json",
              },
            }
          );

          setIsLiked(true);
          setLikeCount((prev) => prev + 1);
        }
      } catch (error) {
        console.log("Error toggling like:", error);
      }
    };
    const handleCommentSubmit = async (e) => {
      e.preventDefault();
      if (!commentText.trim()) return;

      try {
        const formData = new FormData();
        formData.append("comment", commentText);

        const response = await axios.post(
          BaseUrl + `pollComment/${groupdata.id}/${pollData.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );

        if (response.data.status === 200) {
          setComments((prev) => [response.data.data, ...prev]);
          setCommentText("");
        }
      } catch (error) {
        console.error("Error submitting comment:", error);
      }
    };
    const handleCommentLike = async (isCurrentlyLiked, commentId) => {
      try {
        setComments((prevComments) =>
          prevComments.map((comment) => {
            // Check if this is the main comment being liked
            if (comment.comment_id === commentId) {
              return {
                ...comment,
                has_liked_comment: !isCurrentlyLiked,
                comment_likes: isCurrentlyLiked
                  ? comment.comment_likes - 1
                  : comment.comment_likes + 1,
              };
            }

            // Check if this comment has replies that might need updating
            if (comment.replies && comment.replies.length > 0) {
              const updatedReplies = comment.replies.map((reply) => {
                if (reply.comment_id === commentId) {
                  return {
                    ...reply,
                    has_liked_comment: !isCurrentlyLiked,
                    comment_likes: isCurrentlyLiked
                      ? reply.comment_likes - 1
                      : reply.comment_likes + 1,
                  };
                }
                return reply;
              });
              return { ...comment, replies: updatedReplies };
            }

            return comment;
          })
        );
        if (isCurrentlyLiked) {
          await axios.post(
            `${BaseUrl}grouppollcommentunlike/${commentId}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Cookies.get("token")}`,
                Accept: "application/json",
              },
            }
          );
        } else {
          await axios.post(
            `${BaseUrl}grouppollcommentlike/${commentId}/${pollData.id}/${groupdata.id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${Cookies.get("token")}`,
                Accept: "application/json",
              },
            }
          );
        }
      } catch (error) {
        console.log("Error toggling like:", error);
        setComments((prevComments) =>
          prevComments.map((comment) => {
            if (comment.comment_id === commentId) {
              return {
                ...comment,
                has_liked_comment: isCurrentlyLiked,
                comment_likes: isCurrentlyLiked
                  ? comment.comment_likes + 1
                  : comment.comment_likes - 1,
              };
            }
            if (comment.replies && comment.replies.length > 0) {
              const updatedReplies = comment.replies.map((reply) => {
                if (reply.comment_id === commentId) {
                  return {
                    ...reply,
                    has_liked_comment: isCurrentlyLiked,
                    comment_likes: isCurrentlyLiked
                      ? reply.comment_likes + 1
                      : reply.comment_likes - 1,
                  };
                }
                return reply;
              });
              return { ...comment, replies: updatedReplies };
            }
            return comment;
          })
        );
      }
    };
    const handleReplySubmit = async (e, parentId) => {
      e.preventDefault();
      if (!replyText.trim()) return;
      const tempId = Math.floor(Math.random() * 100000);

      const newReply = {
        comment_id: tempId,
        comment: replyText,
        comment_user_name: currentUserRef.current.name,
        comment_user_profile: currentUserRef.current.profile_image,
        created_at: new Date().toISOString(),
        comment_likes: 0,
        has_liked_comment: false,
        comment_post_id: null,
        comment_user_id: currentUser.id,
        comment_parent_id: parentId,
        replies: [],
      };
      setComments((prevComments) =>
        prevComments.map((comment) => {
          if (comment.comment_id === parentId) {
            return {
              ...comment,
              replies: [...comment.replies, newReply],
            };
          }
          return comment;
        })
      );
      try {
        const formData = new FormData();
        formData.append("comment", replyText);

        const response = await axios.post(
          BaseUrl + `pollComment/${groupdata.id}/${pollData.id}/${parentId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
        setReplyText("");
        setReplyingTo(null);
        // if (response.data.status === 200) {
        //   const { reply_to, parent_comment } = response.data.data;

        //   setComments(prevComments => {

        //     if (reply_to && parent_comment) {
        //       return prevComments.map(comment => {
        //         if (comment.comment_id === parseInt(reply_to)) {

        //           return {
        //             ...parent_comment,
        //           };
        //         }
        //         return comment;
        //       });
        //     }

        //     return [parent_comment, ...prevComments];
        //   });

        // }
      } catch (error) {
        console.error("Error submitting comment:", error);
      }
    };
    const onEmojiClick = (emojiData) => {
      setCommentText((prev) => prev + emojiData.emoji);
    };
    const handleToggleSaveUnsave = async () => {
        setCanSave(!canSave);
        setShowOptions(false);
        if (canSave) {
          await axios.post(
            `${BaseUrl}unsavepost`,
            {
              saved_type: "group_poll",
              savable_id: pollData.id
            },
            {
              headers: {
                Authorization: `Bearer ${Cookies.get("token")}`,
                Accept: "application/json",
              },
            }
          );
        } else {
          await axios.post(
            `${BaseUrl}savepost`,
            { 
              saved_type: "group_poll",
              group_id: groupdata.id,
              savable_id: pollData.id
            },
            {
              headers: {
                Authorization: `Bearer ${Cookies.get("token")}`,
                Accept: "application/json",
              },
            }
          );
        }
    } 

    return (
      <div className="p-4 bg-white shadow rounded-lg">
        <div className="relative flex items-start justify-between space-x-3 mb-4">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 rounded-full overflow-hidden">
              {user_profile ? (
                <img
                  src={user_profile}
                  alt={user_name}
                  className="w-full h-full object-cover border border-gray-200 rounded-full"
                />
              ) : (
                <div className="w-full h-full bg-gray-300 flex items-center justify-center text-white font-semibold text-lg">
                  {user_name?.charAt(0)?.toUpperCase()}
                </div>
              )}
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">{user_name}</h3>
              <p className="text-xs text-gray-500">
                {/* {user.role} •{" "} */}
                {new Date(created_at).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                })}
                {isPollClosed && " • Closed"}
              </p>
            </div>
          </div>
          <PiDotsThree
            className="text-2xl"
            onClick={() => setShowOptions(!showOptions)}
            ref={showButtonRef}
          />
          {showOptions && (
            <div
              ref={showOptionRef}
              className="absolute bg-white border border-gray-300 shadow-lg rounded-l-lg rounded-b-lg z-50 mt-5 w-72 right-0"
            >
              <button
                className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
                onClick={handleToggleSaveUnsave}
              >
                {canSave ? <FaBookmark /> : <FaRegBookmark />}
                {canSave ? "Unsave" : "Save"}
              </button>

              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                <FaLink />
                Copy Link to Post
              </button>

              <button
                className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
                onClick={() => setShowEditPostModal(true)}
              >
                <FaEdit />
                Edit Post
              </button>

              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                <FaTrash />
                Delete Post
              </button>

              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                <FaCommentSlash />
                Disable Comments on this Post
              </button>
            </div>
          )}
        </div>

        <div className="border rounded-lg p-4">
          <h2 className="text-lg font-medium">{question}</h2>
          <p className="text-xs text-gray-500 mb-3">
            {canVote
              ? "You can see how people vote."
              : "This poll has ended. Here are the results."}{" "}
            <span className="text-blue-600 cursor-pointer">Learn more</span>
          </p>

          <div className="space-y-3 mb-4">
            {options?.map((option) => {
              const isSelected = selectedOption === option.id;
              const percentage = totalVotes > 0 ? option.percentage : 0;

              return (
                <button
                  key={option.id}
                  onClick={() =>
                    canVote && onVote(pollData.id, option.id, slug)
                  }
                  className={`w-full text-left p-3 rounded border transition-all ${
                    isSelected || user_selected_option === option.id
                      ? "border-blue-500 bg-blue-50"
                      : !canVote
                      ? "border-gray-200 opacity-70"
                      : "border-gray-200 hover:bg-gray-50"
                  }`}
                  disabled={!canVote || user_selected_option}
                >
                  <div className="flex justify-between items-center mb-1">
                    <span
                      className={isSelected ? "font-medium text-blue-600" : ""}
                    >
                      {option.option_text}
                    </span>
                    {(!canVote || selectedOption !== null) && (
                      <span className="text-sm font-medium">{percentage}%</span>
                    )}
                  </div>
                  {(!canVote || selectedOption !== null) && (
                    <div className="w-full bg-gray-100 rounded-full h-2">
                      <div
                        className="h-full bg-blue-500 rounded-full"
                        style={{ width: `${percentage}%` }}
                      ></div>
                    </div>
                  )}
                </button>
              );
            })}
          </div>
          <div className="flex justify-between text-sm text-gray-500 pt-2">
            <span>
              {totalVotes} votes •{" "}
              {isPollClosed ? "Poll closed" : "Voting open"}
            </span>
            {!isPollClosed && (
              <span>
                Closes at:{" "}
                {new Date(closes_at).toLocaleString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })}
              </span>
            )}
          </div>
        </div>

        <div className="px-4 py-2 text-sm text-gray-500  border-b">
          <div className="flex items-center justify-between space-x-4">
            <span>
              {likeCount} {likeCount === 1 ? "like" : "likes"}
            </span>
            <span>
              {comments.length} {comments.length === 1 ? "comment" : "comments"}
            </span>
          </div>
        </div>

        <div className="flex justify-around py-2 text-gray-500">
          <button
            onClick={(e) => {
              handleLike(e);
            }}
            className={`flex items-center space-x-1 px-4 py-2 rounded-md hover:bg-gray-100 ${
              isLiked ? "text-blue-500" : ""
            }`}
          >
            <i
              className={`fas fa-thumbs-up ${isLiked ? "text-blue-500" : ""}`}
            ></i>
            <span>{isLiked ? "Liked" : "Like"}</span>
          </button>
          <button
            className="flex items-center space-x-1 px-4 py-2 rounded-md hover:bg-gray-100"
            onClick={() => {
              setShowComments(!showComments), setShowAllComments(false);
            }}
          >
            <i className="far fa-comment"></i>
            <span>Comment</span>
          </button>
        </div>

        {showComments && (
          <div className="border-t p-4">
            <form
              onSubmit={(e) => handleCommentSubmit(e)}
              className="relative flex items-start gap-3 mb-4"
            >
              {currentUserRef.current.profile_image ? (
                <img
                  src={currentUserRef.current.profile_image}
                  alt="user"
                  className="w-8 h-8 rounded-full object-cover"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
                  {currentUserRef.current.name?.charAt(0).toUpperCase()}
                </div>
              )}
              <div className="flex-1">
                <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                  <input
                    type="text"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    placeholder="Add a comment..."
                    className="flex-1 outline-none bg-transparent"
                  />
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      😊
                    </button>
                    {commentText.trim() && (
                      <button
                        type="submit"
                        className="text-blue-500 font-medium"
                      >
                        Post
                      </button>
                    )}
                  </div>
                </div>
                {showEmojiPicker && (
                  <EmojiPickerWrapper
                    onEmojiSelect={(emoji) =>
                      setCommentText((prev) => prev + emoji)
                    }
                    onClose={() => setShowEmojiPicker(false)}
                    positionClass="bottom-12 right-0"
                  />
                )}
              </div>
            </form>
            <div className="flex items-center justify-between mb-3 px-2">
              <div className="flex items-center">
                <h3 className="font-medium text-gray-800 text-[15px]">
                  {comments.length}{" "}
                  {comments.length === 1 ? "Comment" : "Comments"}
                </h3>
                {comments.length > 2 && !showAllComments && (
                  <span className="ml-2 text-xs text-gray-500">
                    ({comments.length - 2} hidden)
                  </span>
                )}
              </div>
              <button
                onClick={() => {
                  setShowComments(!showComments), setShowAllComments(false);
                }}
                className="text-sm text-gray-600 hover:text-gray-800 flex items-center group"
              >
                <span className="group-hover:bg-gray-100 p-1.5 rounded-full">
                  <MdClose className="text-lg" />
                </span>
              </button>
            </div>

            <div className="space-y-4">
              {comments
                .slice(0, showAllComments ? comments.length : 2)
                .map((comment) => (
                  <div key={comment.comment_id} className="flex gap-3">
                    <div className="flex-shrink-0">
                      {comment.comment_user_profile ? (
                        <img
                          src={comment.comment_user_profile}
                          alt={comment.comment_user_name}
                          className="w-8 h-8 rounded-full object-cover border border-gray-200"
                        />
                      ) : (
                        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                          {comment.comment_user_name?.[0]?.toUpperCase()}
                        </div>
                      )}
                    </div>

                    <div className="flex-1">
                      <div className="bg-gray-50 rounded-2xl p-3">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-1">
                            <p className="font-medium text-sm font-semibold text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                              {comment.comment_user_name || "User"}
                            </p>
                            {comment.is_author && (
                              <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                Author
                              </span>
                            )}
                          </div>
                          <span className="text-xs text-gray-500">
                            {formatTimeAgo(comment.created_at)}
                          </span>
                        </div>

                        <p className="text-sm text-gray-800 mt-1 whitespace-pre-line">
                          {comment.comment}
                        </p>

                        <div className="flex items-center mt-2 text-xs text-gray-500">
                          <button
                            className={`flex items-center gap-1 hover:text-blue-600 ${
                              comment.has_liked_comment ? "text-blue-600" : ""
                            }`}
                            onClick={() =>
                              handleCommentLike(
                                comment.has_liked_comment,
                                comment.comment_id
                              )
                            }
                          >
                            <i
                              className={`fas fa-thumbs-up ${
                                comment.has_liked_comment ? "text-blue-500" : ""
                              }`}
                            ></i>
                            {comment.comment_likes > 0 && (
                              <span>{comment.comment_likes}</span>
                            )}
                            <span>Like</span>
                          </button>

                          <span className="mx-2 text-gray-800">|</span>

                          {/* Reply button - only show reply count if there are replies */}
                          <button
                            className="flex items-center gap-1 hover:text-blue-600"
                            onClick={() =>
                              setReplyingTo(
                                replyingTo === comment.comment_id
                                  ? null
                                  : comment.comment_id
                              )
                            }
                          >
                            <MdReply className="text-base" />
                            <span className="ml-1">Reply</span>
                            {comment.replies && comment.replies.length > 0 && (
                              <>
                                <span className="mx-1">•</span>
                                <span>{comment.replies.length}</span>
                                {comment.replies.length === 1
                                  ? "reply"
                                  : "replies"}
                              </>
                            )}
                          </button>
                        </div>
                      </div>

                      {/* Replies Section */}
                      {comment.replies && comment.replies.length > 0 && (
                        <div className="mt-2 ml-2 pl-4 border-l-2 border-gray-200">
                          {comment.replies
                            .slice(
                              0,
                              showAllReplies[comment.comment_id]
                                ? comment.replies.length
                                : 2
                            )
                            .map((reply) => (
                              <div
                                key={reply.comment_id}
                                className="flex gap-3 mt-3"
                              >
                                <div className="flex-shrink-0">
                                  {reply.comment_user_profile ? (
                                    <img
                                      src={reply.comment_user_profile}
                                      alt={reply.comment_user_name}
                                      className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                    />
                                  ) : (
                                    <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                      {reply.comment_user_name?.[0]?.toUpperCase()}
                                    </div>
                                  )}
                                </div>

                                <div className="flex-1">
                                  <div className="bg-gray-50 rounded-2xl p-3">
                                    <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-1">
                                        <p className="font-medium font-semibold text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                          {reply.comment_user_name || "User"}
                                        </p>
                                        {reply.is_author && (
                                          <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                            Author
                                          </span>
                                        )}
                                      </div>
                                      <span className="text-xs text-gray-500">
                                        {formatTimeAgo(reply.created_at)}
                                      </span>
                                    </div>

                                    <p className="text-sm text-gray-800 mt-1">
                                      {reply.comment}
                                    </p>

                                    <div className="flex items-center mt-2 text-xs text-gray-500 space-x-4">
                                      <button
                                        className={`flex items-center gap-1 hover:text-blue-600 ${
                                          reply.has_liked_comment
                                            ? "text-blue-600"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          handleCommentLike(
                                            reply.has_liked_comment,
                                            reply.comment_id
                                          )
                                        }
                                      >
                                        <MdThumbUp className="icon" />
                                        {reply.comment_likes > 0 && (
                                          <span>{reply.comment_likes}</span>
                                        )}
                                        <span>Like</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                          {comment.replies.length > 2 && (
                            <button
                              onClick={() =>
                                setShowAllReplies((prev) => ({
                                  ...prev,
                                  [comment.comment_id]:
                                    !prev[comment.comment_id],
                                }))
                              }
                              className="w-full text-left text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors mt-2"
                            >
                              <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                {showAllReplies[comment.comment_id] ? (
                                  <>
                                    <MdKeyboardArrowUp className="mr-1 text-lg" />
                                    Collapse replies
                                  </>
                                ) : (
                                  <>
                                    <MdKeyboardArrowDown className="mr-1 text-lg" />
                                    See {comment.replies.length - 2} more{" "}
                                    {comment.replies.length - 2 === 1
                                      ? "reply"
                                      : "replies"}
                                  </>
                                )}
                              </div>
                            </button>
                          )}
                        </div>
                      )}
                      {/* Reply Form */}
                      {replyingTo === comment.comment_id && (
                        <div className="mt-3 ml-2 pl-4 border-l-2 border-gray-200">
                          <form
                            onSubmit={(e) =>
                              handleReplySubmit(e, comment.comment_id)
                            }
                            className="flex gap-2 items-start"
                          >
                            {currentUserRef.current.profile_image ? (
                              <img
                                src={currentUserRef.current.profile_image}
                                alt="user"
                                className="w-8 h-8 rounded-full object-cover"
                              />
                            ) : (
                              <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
                                {currentUserRef.current.name
                                  ?.charAt(0)
                                  .toUpperCase()}
                              </div>
                            )}
                            <div className="flex-1 flex flex-col">
                              <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                                <input
                                  type="text"
                                  value={replyText}
                                  onChange={(e) => setReplyText(e.target.value)}
                                  placeholder="Add a comment..."
                                  className="flex-1 outline-none bg-transparent"
                                />
                                <div className="relative flex items-center gap-2">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setShowReplyEmojiPicker(!showEmojiPicker)
                                    }
                                    className="text-gray-500 hover:text-gray-700"
                                  >
                                    😊
                                  </button>
                                  {showReplyEmojiPicker && (
                                    <EmojiPickerWrapper
                                      onEmojiSelect={(emoji) =>
                                        setReplyText((prev) => prev + emoji)
                                      }
                                      onClose={() =>
                                        setShowReplyEmojiPicker(false)
                                      }
                                      positionClass="absolute bottom-16 right-0"
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="flex justify-end mt-2">
                                <button
                                  type="button"
                                  onClick={() => setReplyingTo(null)}
                                  className="text-gray-600 text-sm px-3 py-1 rounded-md hover:bg-gray-100 mr-2"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="submit"
                                  disabled={!replyText.trim()}
                                  className="bg-blue-600 text-white text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                                >
                                  Post
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                ))}

              {comments.length > 2 && (
                <div className="pt-2">
                  <button
                    onClick={() => setShowAllComments(!showAllComments)}
                    className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
                  >
                    <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                      {showAllComments ? (
                        <>
                          <MdKeyboardArrowUp className="mr-1 text-lg" />
                          Show fewer comments
                        </>
                      ) : (
                        <>
                          <MdKeyboardArrowDown className="mr-1 text-lg" />
                          Show {comments.length - 2} more{" "}
                          {comments.length - 2 === 1 ? "comment" : "comments"}
                        </>
                      )}
                    </div>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {showEditPostModal && (
          <EditPostModal
            open={showEditPostModal}
            pollData={pollData}
            groupData={groupdata}
            type={"poll"}
            onClose={() => setShowEditPostModal(false)}
          />
        )}
      </div>
    );
  };


  const handleVote = async (pollId, optionId, slug) => {
    setSelectedOptions((prev) => ({ ...prev, [pollId]: optionId }));
    setFeed((prev) => {
      return prev.map((item) => {
        if (item?.id === pollId && item?.type === "poll") {
          return {
            ...item,
            options: item.options.map((opt) => ({
              ...opt,
              vote_count:
                opt.id === optionId ? opt.vote_count + 1 : opt.vote_count,
              percentage:
                opt.id === optionId
                  ? Math.round(
                      ((opt.vote_count + 1) / (item.totalVotes + 1)) * 100
                    )
                  : Math.round((opt.vote_count / (item.totalVotes + 1)) * 100),
            })),
            totalVotes: item.totalVotes + 1,
            user_selected_option: optionId,
          };
        }
        return item;
      });
    });

    try {
      const response = await axios.post(
        BaseUrl + `votePoll/${slug}`,
        { option_id: optionId },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      // if(response.data.status === 200){
      //   setPollTriggered(!pollTriggered);
      // }
      // console.log(response.data,"response.data");
      // setFeed(prev =>  prev.map(item => {
      //     if (item?.id === pollId && item?.type === 'poll') {
      //       return {
      //         ...item,
      //         options: response.data.options?.map(option => ({
      //           ...opt,
      //           text: option.option_text,
      //           vote_count: option.vote_count || 0,
      //           percentage: option.percentage || 0,
      //           is_voted: option.is_voted || false
      //         })),
      //         totalVotes: response.data?.total_votes || response.data?.totalVotes || 0,
      //         user_selected_option: response.data?.user_voted_option || optionId
      //       };
      //     }
      //     return item;
      //   })
      // );
      // setFeed(prev => prev.map(item => {
      //       if (item.id === pollId && item.type === 'poll') {
      //         return {
      //           ...item,
      //           options: item.options.map(opt => ({
      //             ...opt,
      //             vote_count: opt.id === optionId ? opt.vote_count + 1 : opt.vote_count,
      //             percentage: opt.id === optionId ?
      //               Math.round(((opt.vote_count + 1) / (item.totalVotes + 1)) * 100) :
      //               Math.round((opt.vote_count / (item.totalVotes + 1)) * 100)
      //           })),
      //           totalVotes: item.totalVotes + 1,
      //           user_selected_option: optionId
      //         };
      //       }
      //       return item;
      //     }));
    } catch (error) {
      console.error("Error in Voting Poll:", error);
    }
  };

  const toggleExpandPost = (postId) => {
    setExpandedPosts((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };

  const formatContent = (content) => {
    return content.split(/(https?:\/\/[^\s]+)/g).map((part, i) => {
      if (part.match(/^https?:\/\//)) {
        return (
          <a
            key={i}
            href={part}
            className="text-blue-500 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const handleLike = (postId) => {
    setFeed((prev) =>
      prev.map((item) => {
        if (item.id === postId && item.type === "post") {
          return {
            ...item,
            likes: item.likes + 1,
          };
        }
        return item;
      })
    );
  };

  const handleWithdraw = async (id) => {
    try {
      const response = await axios.post(
        BaseUrl + `removerequest/${slug}/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        getuserdetails();
        getInvites(slug);
      }
    } catch (error) {
      console.error("Join request failed:", error);
    }
  };
  const handleJoin = async () => {
    try {
      const response = await axios.post(
        BaseUrl + `joingroup/${slug}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        if (groupdata.group_type === "Private") {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Request sent successfully!",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Joined successfully!",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
        getuserdetails();
      }
    } catch (error) {
      console.error("Join request failed:", error);
    }
  };
  const handleAcceptInvite = async () => {
    try {
      const response = await axios.post(
        BaseUrl + `acceptgroupinvite/${slug}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        getuserdetails();
      }
    } catch (error) {
      console.error("Join request failed:", error);
    }
  };
  const handleLeaveGroup = async (groupId) => {
    const token = Cookies.get("token");
    try {
      const result = await axios.post(
        BaseUrl + `leavegroup/${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (result.data.status === 200) {
        navigate("/groups");
        Swal.fire({
                  icon: 'success',
                  title: 'You have left the group successfully',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
      }else {
        Swal.fire({
          icon: "error",
          title: "Failed to leave the group",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error leaving group:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to left the group",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };
  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-10">
          <div className=" container mx-auto flex flex-col lg:flex-row py-4 px-4 sm:px-6 lg:px-8">
            {/* Left Sidebar */}
            <div className=" w-full lg:w-[20%] pt-4 pr-4 ">
              <div className="bg-white rounded-lg border ">
                <div className="relative">
                  {user.cover_image ? (
                    <img
                      src={user.cover_image}
                      alt="Creative design background"
                      className="w-full h-24 object-cover rounded-t-lg"
                    />
                  ) : (
                    <img
                      src={"/Images/cover-img.jpg"}
                      alt="Creative design background"
                      className="w-full h-28 object-cover rounded-t-lg"
                    />
                  )}

                  <div className="absolute bottom-4 left-16 transform translate-y-1/2">
                    {user.profile_image ? (
                      <img
                        src={user.profile_image}
                        alt="Profile of Erikson George"
                        className="size-20 rounded-full border-4 border-white"
                      />
                    ) : (
                      <div className="size-20 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-3xl">
                        {user?.name?.charAt(0) || "U"}
                      </div>
                    )}
                  </div>
                </div>

                <div className="py-8 px-6">
                  <div className="">
                    <div className="flex flex-col justify-between">
                      <div className="flex items-center justify-center ">
                        <h1 className="text-sm font-semibold ">
                          {user.name}{" "}
                          {groupdata.is_owner && (
                            <span className="text-gray-500 text-sm bg-gray-100 px-1  ">
                              Owner
                            </span>
                          )}
                          {groupdata.is_manager && (
                            <span className="text-gray-500 text-sm bg-gray-100 px-1  ">
                              Manager
                            </span>
                          )}
                        </h1>
                      </div>
                      {groupdata.is_owner || groupdata.is_manager ? (
                        <div className="text-[12px] text-gray-600 text-center">
                          <p>Group created: {groupdata.created_date}</p>
                        </div>
                      ) : (
                        <div className="text-[12px] text-gray-600 text-center">
                          <p>Joined group: {groupdata.created_date}</p>
                        </div>
                      )}
                    </div>
                    {groupdata.is_owner ||
                      (groupdata.is_manager && (
                        <div className="mt-8">
                          <div className="flex justify-between">
                            <p className="text-[13px]  text-gray-500 font-medium">
                              Pending Posts
                            </p>
                            <p className="text-[13px]  text-blue-500 font-medium">
                              0
                            </p>
                          </div>
                          <div className="flex justify-between">
                            <p className="text-[13px] mt-1 text-gray-500 ont-medium">
                              Requests to join
                            </p>
                            <p className="text-[13px] mt-1 text-blue-500 font-medium">
                              0
                            </p>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                {groupdata.is_owner && (
                  <>
                    <div className="border-y py-3">
                      <Link to={`/groups/managegroup/${groupdata.slug}`}>
                        <p className="text-sm font-medium text-gray-800 text-center">
                          Manage group
                        </p>
                      </Link>
                    </div>
                    <div className=" py-3">
                      <p
                        className="text-sm font-medium text-gray-800 text-center"
                        onClick={() => setModalopen(true)}
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Edit group
                      </p>
                    </div>
                  </>
                )}
                {groupdata.is_manager && !groupdata.is_owner && (
                  <>
                    <div className="border-y py-3">
                      <Link to={`/groups/managegroup/${groupdata.slug}`}>
                        <p className="text-sm font-medium text-gray-800 text-center">
                          Manage group
                        </p>
                      </Link>
                    </div>
                  </>
                )}
              </div>

              <div className="border bg-white rounded-lg mt-2">
                <div className="pt-4">
                  {/*  <div
                    className="flex justify-between items-center  cursor-pointer px-4 hover:text-gray-600 group"
                    onClick={toggleDropdown}
                  >
                    <div className="flex flex-col ">
                      <p className="text-[12px]">Recent</p>
                    </div>
                    <p className="text-[22px] text-white group-hover:text-gray-600 group-hover:bg-gray-100 group-hover:rounded-full p-1">
                      {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                    </p>
                  </div>
                  {isOpen && (
                    <div className="flex flex col gap-2 mt-2 text-gray-600 px-4">
                      <FaPeopleGroup />
                      <p className="text-[12px] text-gray-600">Technoites</p>
                    </div>
                  )} */}
                  <div
                    className="flex justify-between items-center  cursor-pointer px-4 hover:text-gray-600 group  "
                    onClick={toggleDropdown2}
                  >
                    <div className="flex flex-col ">
                      <Link
                        to={"/groups"}
                        className="text-[12px] text-blue-600"
                      >
                        Groups
                      </Link>
                    </div>
                    <p className="text-[22px] text-white group-hover:text-gray-600 group-hover:bg-gray-100 group-hover:rounded-full p-1">
                      {isOpen2 ? (
                        <MdKeyboardArrowUp />
                      ) : (
                        <MdKeyboardArrowDown />
                      )}
                    </p>
                  </div>
                  {isOpen2 && (
                    <>
                      {groups.map((group, index) => (
                        <div
                          className="flex  mt-2 text-gray-600 px-4"
                          key={index}
                        >
                          <Link
                            to={`/groups/${group.slug}`}
                            className="flex gap-2"
                          >
                            <FaPeopleGroup />
                            <p className="text-[12px] text-gray-600">
                              {group.group_name}
                            </p>
                          </Link>
                        </div>
                      ))}

                      <Link to={"/groups"}>
                        <p className="text-center text-[12px] text-gray-700 mt-2 hover:bg-gray-200 py-1">
                          See all
                        </p>
                      </Link>
                    </>
                  )}
                  <div className="flex justify-between items-center  cursor-pointer px-4 ">
                    <div className="flex flex-col ">
                      <Link
                        to={`/events`}
                        className="text-[12px] text-blue-600"
                      >
                        Events
                      </Link>
                    </div>
                    <div className="flex">
                      {/* <p className="text-[22px] text-gray-600 hover:bg-gray-100 hover:rounded-full p-1">
                        <IoMdAdd />
                      </p> */}
                      <p
                        className="text-[22px] text-gray-600 group-hover:text-gray-600 group-hover:bg-gray-100 group-hover:rounded-full p-1"
                        onClick={toggleDropdown}
                      >
                        {isOpen ? (
                          <MdKeyboardArrowUp />
                        ) : (
                          <MdKeyboardArrowDown />
                        )}
                      </p>
                    </div>
                  </div>
                  {isOpen && (
                    <>
                      {events.map((event, index) => (
                        <div
                          className="flex  mt-2 text-gray-600 px-4"
                          key={index}
                        >
                          <Link
                            to={`/groups/${event.slug}`}
                            className="flex gap-2"
                          >
                            <FaCalendarDays />
                            <p className="text-[12px] text-gray-600">
                              {event.event_name}
                            </p>
                          </Link>
                        </div>
                      ))}

                      <Link to={"/events/allevents"}>
                        <p className="text-center text-[12px] text-gray-700 mt-2 hover:bg-gray-200 py-1">
                          See all
                        </p>
                      </Link>
                    </>
                  )}

                  <div className="text-[14px] flex items-center justify-center text-gray-600  hover:bg-gray-200 p-4 font-semibold border-t">
                    <Link to={`/groups/discover`}>
                      <button>Discover more</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="w-full lg:w-[55%] p-4">
              <div className="bg-white rounded-lg mb-4 pb-4">
                <div className="relative">
                  <img
                    src={
                      groupdata.cover_image !== null
                        ? groupdata.cover_image
                        : "/Images/cover-img.jpg"
                    }
                    alt="Creative design background"
                    className="w-full h-40 object-cover rounded-t-lg"
                  />
                  <div className="absolute top-8 left-6 transform translate-y-1/2">
                    <img
                      src={
                        groupdata.image !== null
                          ? groupdata.image
                          : "/Images/user-img.jpg"
                      }
                      alt="Profile of Erikson George"
                      className="size-32  border-4 border-white"
                    />
                  </div>
                  <div className="absolute flex text-[24px] text-gray-900 space-x-4 bottom-[-40px] right-6">
                    {(groupdata.is_owner ||
                      groupdata.is_manager ||
                      groupdata.is_member) && (
                      <button onClick={aboutopenModal}>
                        <FcAbout />
                      </button>
                    )}

                    {isaboutopen && (
                      <div
                        className="fixed inset-0 bg-gray-800 bg-opacity-40 flex items-center justify-center z-50 "
                        onClick={() => aboutcloseModal()}
                      >
                        <div
                          className="bg-white shadow-lg rounded-[30px] w-full max-w-xl mx-auto border-8 border-gray-500 "
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="flex justify-between items-center p-4 rounded-t-[30px] border-b ">
                            <h2 className="text-xl font-semibold">
                              About this group
                            </h2>
                            <button
                              onClick={aboutcloseModal}
                              className="text-gray-500 hover:text-gray-700"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <div className="py-6 px-4 overflow-y-auto max-h-[500px]">
                            <div className="border-b">
                              <p className="text-xl font-semibold text-gray-800">
                                Description
                              </p>
                              <p className="text-gray-600 text-sm my-4">
                                {groupdata.description}
                              </p>
                            </div>
                            <div className="border-b mt-6">
                              <p className="text-xl font-semibold text-gray-800">
                                Details
                              </p>
                              <div className="text-gray-600 text-sm my-4">
                                {groupdata.group_type === "Public" ? (
                                  <div>
                                    <div className="">
                                      <span>Public</span>
                                      <p>
                                        Anyone, on or off LinkedIn can see posts
                                        in the group. The group appears in
                                        search results and is visible to others
                                        on members’ profiles.
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  <div>
                                    <span>Private</span>
                                    <p>
                                      Only members can see posts in this group.
                                    </p>
                                  </div>
                                )}
                              </div>
                              {groupdata.group_type === "Private" ? (
                                <div className="text-gray-600 text-sm my-4">
                                  {groupdata.discoverability === "Listed" ? (
                                    <div>
                                      <div className="">
                                        <span>Listed</span>
                                        <p>
                                          The group appears in search results,
                                          is visible to others on members’
                                          profiles, and LinkedIn users can see
                                          whether a connection is a member.
                                        </p>
                                      </div>
                                    </div>
                                  ) : (
                                    <div>
                                      <span>Unlisted</span>
                                      <p>
                                        The group does not appear in search
                                        results for non-group members and is not
                                        visible to non-group members on members’
                                        profiles.
                                      </p>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                              {groupdata.industry_id && (
                                <div className="text-gray-600 text-sm my-4">
                                  <span>Industry</span>
                                  <p>
                                    {groupdata.industry_id
                                      ?.map(
                                        (industry) => industry.industry_name
                                      )
                                      .join(" , ")}
                                  </p>
                                </div>
                              )}
                              {groupdata.location && (
                                <div className="text-gray-600 text-sm my-4">
                                  <span>Location</span>
                                  <p>{groupdata.location}</p>
                                </div>
                              )}
                              {groupdata.created_date && (
                                <div className="text-gray-600 text-sm my-4">
                                  <span>Created</span>
                                  <p>{groupdata.created_date}</p>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                            <button
                              onClick={aboutcloseModal}
                              className="bg-blue-600 text-white px-4 py-1 rounded-xl text-base font-semibold"
                            >
                              Done
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="relative inline-block" ref={dropdownRef}>
                      <button onClick={() => setIsShared(!isShared)}>
                        <PiArrowBendUpRightBold />
                      </button>

                      {isShared && (
                        <div
                          className="absolute z-50 mt-2 right-0 bg-white shadow-lg rounded-lg w-48"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="pt-4 text-base text-left">
                            <p className="px-4">Share on LinkUp</p>
                            <div className="border-b py-2">
                              <div className="flex items-center text-gray-600 space-x-1 px-4 hover:bg-gray-100 py-2">
                                <MdModeEdit className="text-xl" />
                                <p className="text-sm">Repost to Feed</p>
                              </div>
                              <div className="flex items-center text-gray-600 space-x-1 px-4 hover:bg-gray-100 py-2">
                                <BsFillCursorFill className="text-xl" />
                                <p className="text-sm">Send in a Message</p>
                              </div>
                            </div>
                            <p className="px-4 pt-2">Other options</p>
                            <div className="py-2">
                              <div className="flex items-center text-gray-600 space-x-1 px-4 hover:bg-gray-100 py-2">
                                <IoIosLink className="text-xl" />
                                <p className="text-sm">Copy Link</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {(groupdata.is_owner ||
                      groupdata.is_manager ||
                      groupdata.is_member) && (
                      <>
                        {groupdata.admin_approve && groupdata.allow_invite ? (
                          <button onClick={() => setIsNotify(!isnotify)}>
                            <FaBell />
                            {isnotify && (
                              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-start justify-start z-10 ">
                                <div className="bg-white shadow-lg rounded-[30px] w-full max-w-xl mx-auto border-8 border-gray-500 mt-20 ">
                                  <div className="flex justify-between items-center p-4 rounded-t-[30px] border-b ">
                                    <h2 className="text-xl font-semibold">
                                      Notification settings disabled
                                    </h2>
                                    <button
                                      onClick={() => setIsNotify(!isnotify)}
                                      className="text-gray-500 hover:text-gray-700"
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </div>
                                  <div className="py-6 px-4 overflow-y-auto max-h-[500px]">
                                    <div className="">
                                      <p className="text-base  text-gray-800">
                                        Since all posts in this group require
                                        admin review, group admins will receive
                                        all group notifications.
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                                    <button
                                      onClick={() => setIsNotify(!isnotify)}
                                      className="bg-blue-600 text-white px-4 py-1 rounded-xl text-base font-semibold"
                                    >
                                      Ok
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </button>
                        ) : groupdata.admin_approve ? (
                          <button onClick={() => setIsNotify(!isnotify)}>
                            <FaBell />
                            {isnotify && (
                              <div
                                className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-start justify-start z-10 "
                                onClick={() => setIsNotify(false)}
                              >
                                <div
                                  className="bg-white shadow-lg rounded-[30px] w-full max-w-xl mx-auto border-8 border-gray-500 mt-20"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="flex justify-between items-center p-4 rounded-t-[30px] border-b ">
                                    <h2 className="text-xl font-semibold">
                                      Notification settings disabled
                                    </h2>
                                    <button
                                      onClick={() => setIsNotify(!isnotify)}
                                      className="text-gray-500 hover:text-gray-700"
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </div>
                                  <div className="py-6 px-4 overflow-y-auto max-h-[500px]">
                                    <div className="">
                                      <p className="text-base  text-gray-800">
                                        Since all posts in this group require
                                        admin review, group admins will receive
                                        all group notifications.
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                                    <button
                                      onClick={() => setIsNotify(!isnotify)}
                                      className="bg-blue-600 text-white px-4 py-1 rounded-xl text-base font-semibold"
                                    >
                                      Ok
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </button>
                        ) : groupdata.allow_invite ? (
                          <button
                            onClick={() => setIsNotification(!isnotification)}
                          >
                            <MdNotificationsActive />
                            {isnotification && (
                              <div
                                className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-start justify-start z-10 "
                                onClick={() => setIsNotification(false)}
                              >
                                <div
                                  className="bg-white shadow-lg rounded-[30px] w-full max-w-sm mx-auto border-8 border-gray-500 mt-20"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="flex justify-between items-center py-4 px-6 rounded-t-[30px] border-b ">
                                    <h2 className="text-xl font-semibold">
                                      Manage notifications about{" "}
                                      {groupdata.group_name}
                                    </h2>
                                    <button
                                      onClick={() =>
                                        setIsNotification(!isnotification)
                                      }
                                      className="text-gray-500 text-base hover:text-gray-700"
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </div>
                                  <div className="mt-4 space-y-3">
                                    <div
                                      className={`flex items-center justify-between p-2 rounded cursor-pointer px-6 `}
                                      onClick={(e) => setSelected("all")}
                                    >
                                      <div className="flex items-center gap-3">
                                        <MdNotificationsActive className="text-gray-600 text-lg" />
                                        <span className="text-gray-700 text-base">
                                          All
                                        </span>
                                      </div>
                                      <div
                                        className={`w-5 h-5 border-2 rounded-full flex items-center justify-center  ${
                                          selected === "all"
                                            ? "border-green-500"
                                            : "border-gray-400"
                                        }`}
                                      >
                                        {selected === "all" && (
                                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      className={`flex items-center justify-between p-2 rounded cursor-pointer px-6  `}
                                      onClick={(e) => setSelected("relevant")}
                                    >
                                      <div className="flex flex-col">
                                        <div className="flex gap-3 items-center">
                                          <FaBell className="text-gray-600 text-lg" />
                                          <div className="flex flex-col items-start">
                                            <p className="text-gray-700 text-base">
                                              Most relevant
                                            </p>
                                            <p className="text-[12px] text-gray-500 ">
                                              Personalized based on your
                                              activity
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                                          selected === "relevant"
                                            ? "border-green-500"
                                            : "border-gray-400"
                                        }`}
                                      >
                                        {selected === "relevant" && (
                                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      className={`flex items-center justify-between p-2 rounded cursor-pointer px-6  `}
                                      onClick={(e) => setSelected("off")}
                                    >
                                      <div className="flex items-center gap-3">
                                        <FaBellSlash className="text-gray-600 text-lg" />
                                        <span className="text-gray-700 text-base">
                                          Off
                                        </span>
                                      </div>
                                      <div
                                        className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                                          selected === "off"
                                            ? "border-green-500"
                                            : "border-gray-400"
                                        }`}
                                      >
                                        {selected === "off" && (
                                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                                    <button
                                      onClick={() =>
                                        setIsNotification(!isnotification)
                                      }
                                      className="bg-blue-600 text-white px-4 py-1 rounded-xl text-base font-semibold"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </button>
                        ) : null}
                      </>
                    )}

                    {groupdata.is_owner && (
                      <button
                        onClick={() => setModalopen(true)}
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        <MdModeEdit />
                      </button>
                    )}

                    <div className="relative inline-block" ref={dropdown1Ref}>
                      <button onClick={() => setIsSettings(!isSettings)}>
                        <PiDotsThreeOutlineFill />
                      </button>
                      {isSettings && (
                        <div
                          className=" absolute right-0 mt-2 bg-white shadow-lg rounded-2xl w-52 z-20"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="py-2">
                            <div
                              className=" flex items-center text-gray-600 space-x-1 px-4 hover:bg-gray-100 py-2"
                              onClick={() => openNotification()}
                            >
                              <FaBell className="text-gray-600 text-lg" />
                              <p className="text-sm">Manage notification</p>
                            </div>
                            {isnotification && (
                              <div
                                className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-start justify-start z-10 "
                                onClick={() => setIsNotification(false)}
                              >
                                <div
                                  className="bg-white shadow-lg rounded-[30px] w-full max-w-sm mx-auto border-8 border-gray-500 mt-20"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="flex justify-between items-center py-4 px-6 rounded-t-[30px] border-b ">
                                    <h2 className="text-xl font-semibold">
                                      Manage notifications about{" "}
                                      {groupdata.group_name}
                                    </h2>
                                    <button
                                      onClick={() =>
                                        setIsNotification(!isnotification)
                                      }
                                      className="text-gray-500 text-base hover:text-gray-700"
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </div>
                                  <div className="mt-4 space-y-3">
                                    <div
                                      className={`flex items-center justify-between p-2 rounded cursor-pointer px-6 `}
                                      onClick={(e) => setSelected("all")}
                                    >
                                      <div className="flex items-center gap-3">
                                        <MdNotificationsActive className="text-gray-600 text-lg" />
                                        <span className="text-gray-700 text-base">
                                          All
                                        </span>
                                      </div>
                                      <div
                                        className={`w-5 h-5 border-2 rounded-full flex items-center justify-center  ${
                                          selected === "all"
                                            ? "border-green-500"
                                            : "border-gray-400"
                                        }`}
                                      >
                                        {selected === "all" && (
                                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      className={`flex items-center justify-between p-2 rounded cursor-pointer px-6  `}
                                      onClick={(e) => setSelected("relevant")}
                                    >
                                      <div className="flex flex-col">
                                        <div className="flex gap-3 items-center">
                                          <FaBell className="text-gray-600 text-lg" />
                                          <div className="flex flex-col items-start">
                                            <p className="text-gray-700 text-base">
                                              Most relevant
                                            </p>
                                            <p className="text-[12px] text-gray-500 ">
                                              Personalized based on your
                                              activity
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                                          selected === "relevant"
                                            ? "border-green-500"
                                            : "border-gray-400"
                                        }`}
                                      >
                                        {selected === "relevant" && (
                                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      className={`flex items-center justify-between p-2 rounded cursor-pointer px-6  `}
                                      onClick={(e) => setSelected("off")}
                                    >
                                      <div className="flex items-center gap-3">
                                        <FaBellSlash className="text-gray-600 text-lg" />
                                        <span className="text-gray-700 text-base">
                                          Off
                                        </span>
                                      </div>
                                      <div
                                        className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                                          selected === "off"
                                            ? "border-green-500"
                                            : "border-gray-400"
                                        }`}
                                      >
                                        {selected === "off" && (
                                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                                    <button
                                      onClick={() =>
                                        setIsNotification(!isnotification)
                                      }
                                      className="bg-blue-600 text-white px-4 py-1 rounded-xl text-base font-semibold"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="flex items-center text-gray-600 space-x-1 px-4 hover:bg-gray-100 py-2">
                              <IoMdSettings className="text-gray-600 text-lg" />
                              <p className="text-sm">Update your settings </p>
                            </div>
                            <div
                              className="flex items-center text-gray-600 space-x-1 px-4 hover:bg-gray-100 py-2"
                              onClick={() => openLeave()}
                            >
                              <IoExitOutline className="text-gray-600 text-lg" />
                              <p className="text-sm">Leave this group</p>
                            </div>
                            {isLeave && (
                              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-start justify-start z-10 ">
                                <div className="bg-white shadow-lg rounded-[30px] w-full max-w-xl mx-auto border-8 border-gray-500 mt-20 ">
                                  <div className="flex justify-between items-center p-4 rounded-t-[30px] border-b ">
                                    <h2 className="text-xl font-semibold">
                                      Leave this group
                                    </h2>
                                    <button
                                      onClick={() => closeLeave()}
                                      className="text-gray-500 hover:text-gray-700"
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </div>
                                  <div className="py-6 px-4 overflow-y-auto max-h-[500px]">
                                    <div className="">
                                      <p className="text-base  text-gray-800">
                                        You will no longer be able to access the
                                        conversations in this group. Would you
                                        still like to leave this group?
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex justify-end gap-4 border-t-[1px] border-gray-200 py-4 px-8 ">
                                    <button
                                      onClick={() => setIsLeave(!isLeave)}
                                      className=" text-gray-600 px-4 py-1 rounded-xl text-base font-semibold border border-gray-600"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleLeaveGroup(groupdata.id)
                                      }
                                      className="bg-blue-600 text-white px-4 py-1 rounded-xl text-base font-semibold"
                                    >
                                      Leave
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="pt-20 px-6">
                  <div className=" ">
                    <div className="flex justify-between">
                      <div className="flex items-center space-x-4 ">
                        <h1 className="text-2xl font-bold">
                          {groupdata.group_name}
                        </h1>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2 mb-2">
                      <FaPeopleGroup />
                      <p className=" text-gray-600">
                        {" "}
                        {groupdata.group_type} {groupdata.discoverability}
                      </p>
                    </div>

                    <p className="text-blue-600 text-[14px]">
                      Earn an Active Group badge
                    </p>

                    {!(
                      groupdata.is_owner &&
                      groupdata.is_manager &&
                      groupdata.is_member
                    ) && (
                      <p className="text-gray-700 text-sm mt-2">
                        {groupdata.connection_count}{" "}
                        {groupdata.connection_count > 1 ? "members" : "member"}
                      </p>
                    )}

                    {!(
                      groupdata.is_owner &&
                      groupdata.is_manager &&
                      groupdata.is_member
                    ) &&
                      groupdata.group_type === ("Private" || "Public") && (
                        <>
                          {user.is_invited ? (
                            <button
                              onClick={handleAcceptInvite}
                              className="mt-2 px-4 py-1 bg-blue-500 text-white rounded-full"
                            >
                              Accept
                            </button>
                          ) : user.is_requested ? (
                            <button
                              onClick={() => handleWithdraw(groupdata.user.id)}
                              className="mt-2 px-4 py-1 bg-blue-500 text-white rounded-full"
                            >
                              Withdraw Request
                            </button>
                          ) : user.is_connected ? (
                            ""
                          ) : (
                            <button
                              onClick={handleJoin}
                              className="mt-2 px-4 py-1 bg-blue-500 text-white rounded-full"
                            >
                              Join Group
                            </button>
                          )}
                        </>
                      )}

                    {groupdata.is_member && (
                      <div className="flex items-center justify-between">
                        <div className="flex gap-2">
                          {groupdata.allow_invite && (
                            <div>
                              <button
                                className="mt-2 px-4 py-1 bg-blue-500 text-white rounded-full"
                                onClick={handleInviteConnections}
                              >
                                Invite
                              </button>
                              {isModalOpen && (
                                <ConnectionModal
                                  isOpen={isModalOpen}
                                  onClose={() => setIsModalOpen(false)}
                                  connection={connections}
                                  slug={slug}
                                />
                              )}
                            </div>
                          )}
                          <div className="relative">
                            <button
                              className="mt-2 px-4 py-1 bg-white text-blue-500 border border-blue-500 rounded-full cursor-pointer"
                              onClick={() => setShowShare(!showshare)}
                              ref={showshareButtonRef}
                            >
                              Share
                            </button>
                            {showshare && (
                              <div
                                ref={showShareRef}
                                className="absolute bg-white border border-gray-300 shadow-lg rounded-l-lg rounded-b-lg z-50 mt-2  w-72 right-0"
                              >
                                <button
                                  className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
                                  onClick={handleToggleSave}
                                >
                                  {isSaved ? <FaBookmark /> : <FaRegBookmark />}
                                  {isSaved ? "Unsave" : "Save"}
                                </button>

                                <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                                  <FaLink />
                                  Copy Link to Post
                                </button>

                                <button
                                  className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
                                  onClick={() => setShowEditPostModal(true)}
                                >
                                  <FaEdit />
                                  Edit Post
                                </button>

                                <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                                  <FaTrash />
                                  Delete Post
                                </button>

                                <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                                  <FaCommentSlash />
                                  Disable Comments on this Post
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="relative">
                          <PiDotsThree
                            className="text-2xl"
                            onClick={() => setShowOptions(!showOptions)}
                            ref={showButtonRef}
                          />
                          {showOptions && (
                            <div
                              ref={showOptionRef}
                              className="absolute bg-white border border-gray-300 shadow-lg rounded-l-lg rounded-b-lg z-50  w-72 right-0"
                            >
                              <button
                                className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
                                onClick={handleToggleSave}
                              >
                                {isSaved ? <FaBookmark /> : <FaRegBookmark />}
                                {isSaved ? "Unsave" : "Save"}
                              </button>

                              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                                <FaLink />
                                Copy Link to Post
                              </button>

                              <button
                                className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100"
                                onClick={() => setShowEditPostModal(true)}
                              >
                                <FaEdit />
                                Edit Post
                              </button>

                              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                                <FaTrash />
                                Delete Post
                              </button>

                              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100">
                                <FaCommentSlash />
                                Disable Comments on this Post
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {(groupdata.is_owner ||
                groupdata.is_manager ||
                groupdata.is_member) && (
                <div className="bg-white rounded-lg shadow p-4  mb-4">
                  <div className="flex items-center ">
                    {/* <img
                      src="/Images/newsfeed/ProfilePicture.png"
                      alt="User profile"
                      className="rounded-full w-12 h-12"
                    /> */}
                    {user.profile_image ? (
                      <img
                        src={user.profile_image}
                        alt="Profile of Erikson George"
                        className="size-12 rounded-full"
                      />
                    ) : (
                      <div className="size-12 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-3xl">
                        {user?.name?.charAt(0) || "U"}
                      </div>
                    )}
                    <input
                      type="text"
                      placeholder="Start a post"
                      className="ml-4 w-full p-2 border rounded-full"
                      onClick={() => setModalOpen(true)}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    />
                    {modalOpen && (
                      <GroupPostModal
                        modalOpen={modalOpen}
                        closeModal={() => setModalOpen(false)}
                        groupdata={groupdata}
                        groupowner={groupowner}
                        onGroupCreated={getgroupfeed}
                      />
                    )}
                  </div>
                  <div className="flex justify-around mt-4">
                    <button
                      className="flex items-center text-gray-500"
                      onClick={() => setModalOpen(true)}
                    >
                      <i className="fas fa-image mr-2"></i>Media
                    </button>
                    <button
                      className="flex items-center text-gray-500"
                      onClick={() => setPollOpen(true)}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      <FaPoll /> Poll
                    </button>
                    {pollOpen && (
                      <PollModal
                        pollOpen={pollOpen}
                        pollcloseModal={() => setPollOpen(false)}
                        groupdata={groupdata}
                        groupowner={groupowner}
                        onGroupCreated={getgroupfeed}
                      />
                    )}
                  </div>
                </div>
              )}

              {((groupdata.is_owner ||
                groupdata.is_manager ||
                groupdata.is_member) &&
                groupdata.group_type === "Private") ||
              groupdata.group_type === "Public" ? (
                <>
                  {feed.map(
                    (item) =>
                      item && (
                        <div
                          key={item.id}
                          className="bg-white rounded-lg shadow overflow-hidden border border-gray-200 mb-4"
                        >
                          {item.type === "poll" ? (
                            <LinkedInPoll
                              pollData={item}
                              onVote={handleVote}
                              selectedOption={selectedOptions[item.id]}
                            />
                          ) : (
                            <LinkedInPost
                              postData={item}
                              groupData={groupdata}
                              currentUser={currentUserRef.current}
                              isExpanded={expandedPosts[item.id] || false}
                              onToggleExpand={() => toggleExpandPost(item.id)}
                            />
                          )}
                        </div>
                      )
                  )}
                  {isFetching && (
                    <div className="flex justify-center my-4">
                      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                    </div>
                  )}
                  {!hasMore && (
                    <div className="text-center text-sm text-gray-500 py-4">
                      No more posts to show.
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200 ">
                    <div className="py-4 px-6">
                      <h2 className="text-xl font-semibold">
                        About this group
                      </h2>
                      {groupdata.description && (
                        <p className="text-gray-700 text-sm mt-1">
                          {groupdata.description.slice(0, 150)} ....
                        </p>
                      )}
                    </div>
                    <div
                      className="text-black-600 text-lg bg-gray-100 flex items-center justify-center py-4 border-t border-gray-200 cursor-pointer "
                      onClick={aboutopenModal}
                    >
                      <button>
                        Show all{" "}
                        <span>
                          <EastIcon className="text-sm" />
                        </span>
                      </button>
                    </div>
                  </div>

                  <div className="mb-4 px-6 py-4 bg-white rounded-lg border border-gray-200 mt-4">
                    <h2 className="text-xl font-semibold">Activity</h2>
                    <div className="text-gray-600 text-sm mt-2">
                      <div className="flex items-center">
                        <SlNote className="mr-2 text-lg font-bold text-black " />
                        10+ posts a day
                      </div>
                      <div className="flex items-center mt-2">
                        <FaUserGroup className="mr-2 text-lg font-bold text-black " />
                        +4,300 members in the last week
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-200">
                    <div className="py-4 px-6">
                      <h2 className="text-xl font-semibold">Admins</h2>
                      <div className="space-y-4 mt-2">
                        {displayedAdmins.map((admin) => (
                          <div className="flex items-center" key={admin.name}>
                            {admin.profile_image ? (
                              <img
                                src={admin.profile_image}
                                alt={admin.name}
                                className="w-10 h-10 rounded-full mr-3"
                              />
                            ) : (
                              <div className="w-10 h-10 rounded-full mr-3 flex items-center justify-center bg-blue-500 text-white">
                                {admin.name.charAt(0).toUpperCase()}
                              </div>
                            )}
                            <div>
                              <div className="flex items-center">
                                <p className="font-semibold text-sm">
                                  {admin.name}
                                </p>
                                <span className="ml-2 text-xs bg-gray-200 text-gray-700 px-2 py-0.5 rounded">
                                  {admin.role}
                                </span>
                              </div>
                              <p className="text-gray-600 text-xs mt-1">
                                {admin.position}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {groupowner.length > 1 ? (
                      <div
                        className="text-black-600 text-lg bg-gray-100 flex items-center justify-center py-4 border-t border-gray-200 cursor-pointer"
                        onClick={handleToggle}
                      >
                        <button className="flex items-center">
                          {showAll ? "Show less" : "Show more"}{" "}
                          {showAll ? (
                            <FaChevronUp className="ml-2 text-sm transition-transform duration-600" />
                          ) : (
                            <FaChevronDown className="ml-2 text-sm transition-transform duration-600" />
                          )}
                        </button>
                      </div>
                    ) : (
                      <div className="text-black-600 text-lg bg-gray-100 flex items-center justify-center py-4 border-t border-gray-200">
                        <button disabled>Show all</button>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* Right Sidebar */}
            <div className="w-full lg:w-[25%] p-4 ">
              <div className="max-w-sm mx-auto ">
                <div className="bg-white border py-4 rounded-lg shadow-sm mb-4">
                  <p className="text-gray-700 font-semibold px-4">
                    {memberscount}
                    {memberscount > 1 ? " members" : " member"}
                  </p>
                  <div className="flex flex-col  space-y-2 border-b py-2 px-4">
                    <div className="w-fit">
                      <AvatarGroup max={4} total={members.length}>
                        {members.slice(0, 4).map((member) => (
                          <Avatar
                            key={member.user_id}
                            alt={member.name || "Unknown"}
                            src={
                              member.profile && member.profile !== ""
                                ? member.profile
                                : undefined
                            }
                            onError={() =>
                              console.error(
                                `Failed to load image for ${member.name}: ${member.profile}`
                              )
                            }
                          >
                            {(!member.profile || member.profile === "") &&
                              member.name?.[0]}
                          </Avatar>
                        ))}
                      </AvatarGroup>
                    </div>
                    <button
                      className="bg-blue-600 text-white text-sm px-4 py-1 rounded-lg hover:bg-blue-700"
                      onClick={handleInviteConnections}
                    >
                      Invite connections
                    </button>
                    
                    {isModalOpen && (
                      <ConnectionModal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        connection={connections}
                        slug={slug}
                      />
                    )}
                  </div>
                  <Link
                    to={`/groups/managegroup/${groupdata.slug}`}
                    className="flex items-center justify-center w-full mt-3 text-gray-600 hover:text-gray-800"
                  >
                    Show all <MdKeyboardArrowDown className="ml-1" />
                  </Link>
                </div>

                <div className="bg-white border py-4 rounded-lg shadow-sm mb-4 ">
                  <div className="flex flex-col ">
                    <div className="px-4">
                      <p className="text-gray-700 font-semibold">Analytics</p>
                      <p className="text-xs text-gray-500">
                        Last 15 days activity
                      </p>
                    </div>
                    <div className="flex flex-col mt-3 space-y-2">
                      <div className="px-4">
                        <p className="font-bold text-gray-900">0</p>
                        <p className="text-sm text-gray-600 border-b">
                          Active members
                        </p>
                      </div>

                      <div className="px-4">
                        <p className="font-bold text-gray-900">1</p>
                        <p className="text-sm text-gray-600 border-b">
                          New members
                        </p>
                      </div>
                      <div className="px-4">
                        <p className="font-bold text-gray-900">0</p>
                        <p className="text-sm text-gray-600 border-b">Posts</p>
                      </div>
                      <div className="border-b pb-2">
                        <p className="font-bold text-gray-900 px-4">0</p>
                        <p className="text-sm text-gray-600 px-4">Post Views</p>
                      </div>
                    </div>
                    {/* <button onClick={() => setShowAnalytics(!showAnalytics)}>
                  {showAnalytics ? (
                    <MdKeyboardArrowUp className="text-gray-600 text-lg" />
                  ) : (
                    <MdKeyboardArrowDown className="text-gray-600 text-lg" />
                  )}
                </button> */}
                  </div>

                  <button className="flex items-center justify-center w-full mt-3 text-gray-600 hover:text-gray-800">
                    Show all <MdKeyboardArrowDown className="ml-1" />
                  </button>
                </div>
              </div>

              <div className=" rounded-lg">
                <img
                  src="/Images/newsfeed/RightBannerCard.png"
                  alt="Digital Marketing"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          </div>
          <EditGroupModal
            modalOpen={modalopen}
            closeModal={() => setModalopen(false)}
            groupData={groupdata}
            onGroupCreated={getGroupdetails}
          />
        </div>
      )}
    </>
  );
};

export default Groupdetail;
